document.addEventListener('DOMContentLoaded', function () {
  const targetNode = document.getElementById('urgency-engine-snippet-container');
  const config = { childList: true };
  let observer = null;

  if (targetNode) {
    const callback = (mutationsList, obs) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          obs.disconnect();
          if (window.UrgencyInit && typeof window.UrgencyInit.evaluate === 'function') {
            window.UrgencyInit.evaluate();
          }
          updateUrgencyEngineSnippet(obs, config);
          break;
        }
      }
    };

    observer = new MutationObserver(callback);
  }

  updateUrgencyEngineSnippet(observer, config);

  function updateUrgencyEngineSnippet(obs, cfg) {
    if (targetNode && obs) {
      obs.observe(targetNode, cfg);
    }
  }
});
